import React from 'react';
import IncompleteRegistrationSection from "../../components/incomplete-registration-section/IncompleteRegistrationSection";

const IncompleteRegistration = (props) => (
    <IncompleteRegistrationSection {...props}/>
);

export default IncompleteRegistration;